import React from 'react';
import { Trans } from '@lingui/react';

export default {
    availableStudents: <Trans>Available Students</Trans>,
    firstName: <Trans>FIRST NAME</Trans>,
    surname: <Trans>SURNAME</Trans>,
    username: <Trans>USERNAME</Trans>,
    password: <Trans>PASSWORD</Trans>,
    group: <Trans>GROUP</Trans>,
    course: <Trans>COURSE</Trans>,
    noStudents: <Trans>No students available</Trans>
};



// WEBPACK FOOTER //
// ./components/students-table/student-table-text.js